<template>
  <div>
    <!-- 面包屑导航 -->
    <el-page-header @back="goBack" content="车辆编辑"></el-page-header>
    <el-card class="box-card" style="margin-top:20px">
      <el-form
        :inline="false"
        :model="ruleForm"
        :rules="rules"
        ref="formForRef"
        label-width="80px"
        autocomplete="on"
        size="mini"
      >
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="标题" prop="title">
              <el-input placeholder="请输入标题"  v-model="ruleForm.title" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="孔距">
              <el-select v-model="ruleForm.pitch_id" style="width: 200px;" placeholder="请选择车系"  @change="handleIsopenSelect">
                <el-option :key="item.id"  v-for="item in pitchMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

<!--          <el-col :span="7">-->
<!--            <el-form-item label="开始日期" size="small">-->
<!--              <el-date-picker clearable type="date" placeholder="选择开始日期" v-model="addForm.start_time" style="width: 100%;"></el-date-picker>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="7">
            <el-form-item label="车系" prop="style_id">
              <el-select v-model="ruleForm.style_id" placeholder="请选择车系">
                <el-option :key="item.id"  v-for="item in cateMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="年份">
            <el-select
                    v-model="ruleForm.year_id"
                    filterable
                    clearable
                    default-first-option
                    placeholder="请选择年份">
              <el-option
                      v-for="item in carYearList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="中心孔">
              <el-input width="400" placeholder="请输入中心孔"  v-model="ruleForm.center_bore" type="number" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="ET">
              <el-input width="400" placeholder="请输入ET"  v-model="ruleForm.et"  ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="原车尺寸">
              <el-input width="400" placeholder="请输入原车尺寸"  v-model="ruleForm.dimensions"  ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="排序">
              <el-input width="400" placeholder="请输入排序"  v-model="ruleForm.sort" type="number" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="">
              <el-checkbox v-model="ruleForm.is_recommend" label="推荐" ></el-checkbox>
            </el-form-item>
          </el-col>
<!--          <el-col :span="7">-->
<!--            <el-form-item label="所属商家" >-->
<!--              <el-input width="400" placeholder="请输入所属商家" @click.native="chooseM" v-model="ruleForm.shop_name" type="text" ></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="图片">
                <i class="el-icon-camera" style="font-size:80px;" v-show="!ruleForm.file_url" @click="showImgDoc(1,'')"></i>
                <el-image class="main_image"
                          v-show="ruleForm.file_url" :src="ruleForm.file_url" @click="showImgDoc(1,'')"></el-image>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col>-->
<!--            <el-form-item label="图片URL">-->
<!--              <el-input v-model="ruleForm.ad_code"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row>-->
<!--          <el-col>-->
<!--            <el-form-item label="图片">-->
<!--              <el-upload-->
<!--                class="upload-demo"-->
<!--                drag-->
<!--                action="#"-->
<!--                :before-upload="handleBeforeUpload"-->
<!--                :on-success="uploadSuccess"-->
<!--                :auto-upload="false"-->
<!--                :on-change="uploadFile"-->
<!--                :file-list="fileList"-->
<!--                list-type="picture"-->
<!--                multiple-->
<!--              >-->
<!--                <i class="el-icon-upload"></i>-->
<!--                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
<!--                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>-->
<!--              </el-upload>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->

<!--        <el-row>-->
<!--          <el-col>-->
<!--            &lt;!&ndash; 卡片 &ndash;&gt;-->
<!--            <div style="border: 1px solid #ccc;">-->
<!--              <Toolbar-->
<!--                style="border-bottom: 1px solid #ccc"-->
<!--                :editor="editor"-->
<!--                :defaultConfig="toolbarConfig"-->
<!--                :mode="mode"-->
<!--              />-->
<!--              <Editor-->
<!--                style="height: 300px; overflow-y: hidden;"-->
<!--                v-model="ruleForm.content"-->
<!--                :defaultConfig="editorConfig"-->
<!--                :mode="mode"-->
<!--                @onCreated="onCreated"-->
<!--              />-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row style="margin-top: 10px;">
          <el-col>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <eShop  :formData="formData"
            :visible.sync="visible"
            :title="title"
            :closeForm="closeForm"
    />
    <eDocList :formData="formData1"
              :visible.sync="visible1"
              :title="title1"
              :closeForm="closeForm1"
              v-on:eventChoose="eChooseDoc"
    />
  </div>
</template>
<script>
  import eDocList from "../common/eDocList";

  import axios from 'axios'
  //import moment from 'moment'     //日期时间转换
  import eShop from "../common/eShopList";
  import CryptoJS from "crypto-js";
  export default {
    components: { eShop,eDocList  },
    data() {
      return {
        carYearList:[],

        formData:{},
        title:'',
        visible:false,

        formData1:{},
        title1:'',
        visible1:false,
        type_img:1,

        access_token:sessionStorage.getItem('token'),
        company_id:sessionStorage.getItem('company_id'),
        baseUrl:'/api/',
        fileList:[],
        isShowShop:false,
        ruleForm:{
          year_id:'',
          url:'',
          shop_name:'',
          shop_id:'',
          id:'',
          title:'',
          ad_link:'',
          style_id:'',
          pitch_id:'',
          file_url:'',
          content:'',
          is_recommend:0,
          sort:1,
          center_bore:'',
          et:'',
          dimensions:''
        },
        addForm:{
          start_time:"",
          province_id:'',
          city_id:'',
          district_id:''
        },
        cateMenus:[],
        pitchMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          title:[
            { required: true, message: "请输入标题", trigger: 'change' }
          ],
          style_id:[
            { required: true, message: "请选择车系", trigger: 'change' }
          ],

        },
        areaList:[],
        isResouceone: false,


      }
    },
    mounted() {

      // setTimeout(() => {
      //   this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
      // }, 1500)
      this.getCarStyleTree();
      this.getPitchTree();
      this.getCarYeaList();
      let _this=this;

      _this.ruleForm.id = this.$route.query.id;
      if (!isNaN(_this.ruleForm.id)&&_this.ruleForm.id > 0) {
        _this.getOne();
      }

    },
    methods: {
      getCarYeaList(){
        let _this = this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        this.$axios. findCarYearList(params).then((res)=>{
          if(res.code == 200) {
            _this.carYearList=res.data;
          }
        });
      },
      eChooseDoc(id,...params){
        console.log('eChooseDoc',params)
        if(this.type_img==1){
          this.ruleForm.file_url=params[1];
        }
      },
      showImgDoc(type){
        this.type_img=type;
        this.title1="图片选择";
        this.visible1=true;
      },
      closeForm1(){
        console.log('this.formData1---',this.formData1)
        this.visible1=false;
      },

      closeForm(){
        this.ruleForm.shop_id=this.formData.id;
        this.ruleForm.shop_name=this.formData.name;
        this.title="";
        this.visible=false;
      },
      chooseShop(id,...params){
        this.ruleForm.shop_id=id;
        this.ruleForm.shop_name=params[0];
      },
      chooseM(){
        this.title='选择商家';
        this.visible=true;
       // this.isShowShop=true;
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        //let itm=  this.fileList[index];
        this.fileList.splice(index, 1);
        // if(this.ruleForm.id&&this.ruleForm.id>0&&itm.foreign_id){
        //   this.$confirm('此操作将删除该文档, 是否继续?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     const param = {
        //       operator_id: sessionStorage.getItem('user_id'),
        //       company_id:sessionStorage.getItem('company_id'),
        //       access_token:sessionStorage.getItem('token'),
        //       foreign_id: itm.foreign_id,
        //       source: itm.source,
        //       upload_id: itm.upload_id,
        //     }
        //     this.$axios.uploadDel(param).then(res=>{
        //       console.log('-----222222----',res)
        //       if(res.code == 200){
        //         _this.$message.success(res.msg);
        //       }else{
        //         _this.$message.error(res.msg);
        //       }
        //     }).catch(error=>{
        //       console.log(error);
        //     })
        //
        //   }).catch(function(e) {
        //     console.log('e-------')
        //     // 点击取消:不删除了
        //     _this.$message({
        //       type: 'info',
        //       message: '已取消删除'
        //     });
        //   });
        // }

      },
      handleChangeAddress(){     // 更改时调用
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.addForm.province_id=checkedNode[0].path[0];
        _this.addForm.city_id=checkedNode[0].path[1];
        _this.addForm.district_id=checkedNode[0].path[2];
        // console.log('2222',checkedNode[0].path)
        // console.log( checkedNode[0].data.label ) ;  //获取当前点击节点的label值
        // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
      },
      submitForm(){
        let _this=this;
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            // let url= _this.baseUrl+'api/mall.Ad_lz/saveOne';
            // if(_this.ruleForm.ad_id>0){
            //   url= _this.baseUrl+'api/mall.Ad_lz/update';
            // }
            let params={
              access_token:sessionStorage.getItem('token'),
              company_id:sessionStorage.getItem('company_id'),
              id: _this.ruleForm.id,
              center_bore: _this.ruleForm.center_bore,

              dimensions:_this.ruleForm.dimensions,
              et: _this.ruleForm.et,
              title:_this.ruleForm.title,
              style_id:_this.ruleForm.style_id,
              pitch_id:_this.ruleForm.pitch_id,
              file_url: _this.ruleForm.file_url,
              content: _this.ruleForm.content
            };
            if(!isNaN(this.ruleForm.year_id)){
              params.year_id=this.ruleForm.year_id;
            }
            params.is_recommend=this.ruleForm.is_recommend?1:0;
            params.sort=this.ruleForm.sort;
            console.log('params------',params)
              this.$axios.carinfoSaveOne(params).then((res)=>{
                if(res.code==200){
                  this.$message({
                    message:'修改成功！',
                    type:'success',
                    offset:225,
                    duration:1000,
                    onClose:()=>{
                      this.$router.replace('/carList')
                    }
                  });
                }
              });

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){
        let _this=this;
        let param={
          access_token: _this.access_token,
          company_id: _this.company_id,
          id:_this.ruleForm.id
        };
        this.$axios.findCarOne(param).then((res)=>{
          if(res.code==200){
            let item=res.data;
            _this.ruleForm.title=item.title;
            _this.ruleForm.style_id=item.style_id;
            _this.ruleForm.pitch_id=item.pitch_id;
            //_this.ruleForm.content=item.content;
            _this.ruleForm.id=item.id;
            _this.ruleForm.year_id=item.year_id;
            _this.ruleForm.file_url=item.file_url;
            _this.ruleForm.sort=item.sort;
            _this.ruleForm.center_bore=item.center_bore;
            _this.ruleForm.dimensions=item.dimensions;

            _this.ruleForm.et=item.et;
            this.ruleForm.is_recommend=item.is_recommend==1?true:false;
            if(_this.ruleForm.file_url!=''&&_this.ruleForm.file_url!=null){
              var img={
                name:_this.ruleForm.name,
                url:_this.ruleForm.file_url
              }
              _this.fileList.push(img);
            }
          }
          console.log(res);
        });
      },

      async uploadFile (item) {
        let _this=this;
      //  let formData = new FormData()
        let file = item.raw;
        //this.logoFile=item.raw;

        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });

        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200) {
            //文件已经存在
            _this.ruleForm.file_url = res.data.url;
            var img = {
              name: res.data.name,
              url: res.data.url
            }
            _this.fileList.push(img);

          } else {

            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id')
            };
            this.$axios.getAliJsonCmp(param).then(res => {
              let data = res['data'];
              console.log('aliyun', data);
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];
              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
              request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
              request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
              request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
              request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
              request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append('file', file);//需要上传的文件 file
              console.log('aliyun5555', request);
              axios.post(host, request, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
                //请求成功，触发then中的函数
                console.log('upload -res--------', res)
                var fileurl = res.data.filename; //上传完成后的文件oss地址
                var fullurl = host + '/' + fileurl;
                _this.ruleForm.file_url = fullurl;
                var img = {
                  name: fileName,
                  url: fullurl
                }
                _this.fileList.push(img);
                //更新上传资料
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                console.log('upload---save params', upload_params)
                _this.$axios.uploadSave(upload_params).then(resu => {
                  console.log('upload---save', resu)
                });

              })
                .catch(error =>
                  //请求失败，触发catch中的函数 可省略
                  console.log(error)
                )
            });

          }
        });
      },
      async readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async  calculateMD5(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload() {
        console.log('aaaaa');
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },
      goBack() {
        this.$router.go(-1);
      },
      getCarStyleTree(){
        let _this=this;
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.findCarStyleTable(param).then((res)=>{
          if(res.code==200){
            _this.cateMenus=res.data;
          }
          console.log(res);
        });

      },
      getPitchTree(){
        let _this=this;
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.findPitchTable(param).then((res)=>{
          if(res.code==200){
            _this.pitchMenus=res.data;
          }
          console.log(res);
        });

      },
      uploadImg(file, insertFn){

        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJson(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}

          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +'mrh/'+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )

        });

        // let imgData = new FormData();
        // imgData.append('file', file);
        // console.log('lu-----------',file)
        // //调用上传图片接口，上传图片  我这里testUpImg是测试接口
        // testUpImg(imgData).then(response => {
        //   if(response.data.code == 0){
        //     //插入后端返回的url
        //     insertFn(response.data.data.url);
        //   }else{
        //   }
        // })
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },

    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },

  };
</script>
<style>
  /deep/ .input__inner{color:#333}
  .w-e-modal{z-index: 999 !important;left: 300px !important;top: 300px !important;}
  .main_image img {
    width: 100px; /* 设置图片宽度 */
    height: 100px; /* 设置图片高度 */
    display: block;
  }
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
